/* ------------------------------------------------------------
   Whomie Club: speglar temats dolda varukorgsräknare till den
   synliga bubblan i headern.
   Tillagt 2026-07-28.

   Temat gör så här i global.js (rad 2437 och 2559):

     this.cartCount = document.querySelector(".CartCount");
     this.cartCount.innerHTML = "(" + number + ")";

   Alltså uppdateras bara den dolda kroken .CartCount, aldrig den
   synliga .WhomieHeader__CartCount. Bubblan stod därför still på
   gammalt antal tills sidan laddades om.

   Den här filen lyssnar på ändringar i .CartCount och speglar
   siffran. Bubblan skapas om den saknas, vilket den gör när
   korgen är tom, och tas bort igen när antalet blir noll.

   OBS: förväxla inte med assets/whomie-cart.js, som ligger på
   disken men INTE ska kopplas in.
   ------------------------------------------------------------ */
(function () {
  var BUBBLE = "WhomieHeader__CartCount";

  function sync() {
    var source = document.querySelector(".CartCount");
    var link = document.querySelector(".WhomieHeader__Cart");
    if (!source || !link) return;

    var count = parseInt((source.textContent || "").replace(/[^0-9]/g, ""), 10);
    if (isNaN(count)) count = 0;

    var bubble = link.querySelector("." + BUBBLE);

    if (count > 0) {
      if (!bubble) {
        bubble = document.createElement("span");
        bubble.className = BUBBLE;
        link.appendChild(bubble);
      }
      if (bubble.textContent !== String(count)) {
        bubble.textContent = count;
      }
    } else if (bubble) {
      bubble.remove();
    }
  }

  function start() {
    var source = document.querySelector(".CartCount");
    if (!source) return;

    new MutationObserver(sync).observe(source, {
      childList: true,
      characterData: true,
      subtree: true
    });

    sync();
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", start);
  } else {
    start();
  }
})();
